import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { cloneElement } from 'react';
import { Avatar } from "../../../avatar";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getRem } from "./../../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledListItemGraphic = styled(function (_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/cloneElement(children, other);
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isDisabled', 'isStyledAvatar'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  margin-right: ", ";\n  pointer-events: none;\n  ", ";\n"])), getRem(12), function (_ref2) {
  var children = _ref2.children,
      isStyledAvatar = _ref2.isStyledAvatar;
  return children.type !== Avatar && !isStyledAvatar && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: flex;\n      fill: ", ";\n      height: ", ";\n      width: ", ";\n    "])), function (_ref3) {
    var isDisabled = _ref3.isDisabled,
        theme = _ref3.theme;
    return isDisabled ? theme.color.text.light.disabled.value : theme.color.text.light.secondary.value;
  }, getRem(24), getRem(24));
});

var ListItemGraphic = function ListItemGraphic(props) {
  return /*#__PURE__*/_jsx(StyledListItemGraphic, _objectSpread({}, props));
};

ListItemGraphic.displayName = "ListItemGraphic";
ListItemGraphic.propTypes = {
  /** Changes appearance to look visually non-interactable */
  isDisabled: PropTypes.bool,

  /** Changes appearance if children is Avatar styled with styled-components */
  isStyledAvatar: PropTypes.bool
};
ListItemGraphic.defaultProps = {
  isDisabled: false,
  isStyledAvatar: false
};
export { ListItemGraphic };